import React, { useEffect, useState } from 'react';
import { eventService } from '../services';
import { resolveMediaUrl } from '../services/api';
import PageBreadcrumb from '../components/PageBreadcrumb';

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await eventService.getAll();
            setEvents(response.data.data || []);
        } catch (error) {
            console.error('Error fetching events:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-50">
            <PageBreadcrumb
                title="Events & Activities"
                description="Join us in our upcoming initiatives"
                items={[{ label: 'Events' }]}
            />

            <section className="py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {loading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
                        </div>
                    ) : (
                        <div className="space-y-6">
                            {events.map((event) => (
                                <div key={event.id} className="soft-enter hover-lift bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition">
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
                                        {event.featured_image && (
                                            <div className="md:col-span-1 h-48 md:h-auto">
                                                <img src={resolveMediaUrl(event.featured_image)} alt={event.title} className="w-full h-full object-cover" />
                                            </div>
                                        )}
                                        <div className={`p-6 ${event.featured_image ? 'md:col-span-3' : 'col-span-1'}`}>
                                            <h3 className="text-2xl font-bold text-gray-800 mb-2">{event.title}</h3>
                                            <p className="text-gray-600 mb-4 line-clamp-2">{event.description}</p>
                                            <div className="grid grid-cols-2 gap-4 text-sm text-gray-700 mb-6">
                                                <div>
                                                    <p className="font-semibold">Date & Time</p>
                                                    <p>{event.event_date ? new Date(event.event_date).toLocaleDateString() : '-'} {event.event_time ? `at ${event.event_time}` : ''}</p>
                                                </div>
                                                <div>
                                                    <p className="font-semibold">Location</p>
                                                    <p>{event.location}</p>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => setSelectedEvent(event)}
                                                className="bg-emerald-600 text-white px-6 py-2 rounded-lg hover:bg-emerald-700 transition"
                                            >
                                                Learn More
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {selectedEvent && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={() => setSelectedEvent(null)}>
                    <div className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-lg bg-white" onClick={(e) => e.stopPropagation()}>
                        {selectedEvent.featured_image && (
                            <img src={resolveMediaUrl(selectedEvent.featured_image)} alt={selectedEvent.title} className="h-72 w-full object-cover" />
                        )}
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-2">{selectedEvent.title}</h2>
                            <p className="text-sm text-gray-500 mb-4">
                                {selectedEvent.event_date ? new Date(selectedEvent.event_date).toLocaleDateString() : '-'}
                                {selectedEvent.event_time ? ` at ${selectedEvent.event_time}` : ''}
                            </p>
                            <p className="text-gray-700 whitespace-pre-line">{selectedEvent.description}</p>
                            <button onClick={() => setSelectedEvent(null)} className="mt-6 rounded bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Events;
